<template>
  <div>
    <SearchFacetOptions
      :entityType="'Property'"
      :options="agreementTypeOptions"
      :title="'Active Agreement Type'"
      :fieldName="'agreementTypes'"
      :loading="agreementTypeOptionsLoading"
    />
    <MultiTextSearchFacet
      :entityType="'Property'"
      :title="'Property ID'"
      :fieldName="'propertyIds'"
      :placeholderText="'Enter Property ID'"
    />
    <SearchFacetOptions
      :entityType="'Property'"
      :options="propertyStatusOptions"
      :title="'Status'"
      :fieldName="'propertyStatuses'"
      :loading="propertyStatusOptionsLoading"
    />
    <SearchFacetOptions
      :entityType="'Property'"
      :options="localityOptions"
      :title="'Locality'"
      :fieldName="'localities'"
      :loading="localityLoading"
    />
    <div class="row search-filter-category">
      <div class="col-12">
        <a v-b-toggle="`collapse-calculated-acres-facet`" class="facet-collapse-icon c-pointer">
          <font-awesome-icon
            class="when-opened "
            icon='caret-down'
            size="lg" />
          <font-awesome-icon
            class="when-closed fa-w-10"
            icon='caret-right'
            size="lg" />
        </a>
        <span class="font-weight-bold ">Calculated Acres</span>
        <b-collapse :id="`collapse-calculated-acres-facet`"
          class="row"
          :visible="initialSearchCategoryStates['acres']">
          <div class="search-panel-items search-panel-no-border search-filter-list">
            <div class="search-panel-sub-item">
              <span class="sub-search-type-filter">Minimum Acres</span>
              <input class="form-control text-search-entry"
                v-validate="'max_decimal:4'"
                placeholder="Enter Minimum Acres"
                name="minimumAcres"
                data-vv-as="Minimum Acres"
                v-model="minimumAcres"/>
              <div class="invalid-feedback">{{ errors.first('minimumAcres') }}</div>
            </div>
            <div class="search-panel-sub-item">
              <span class="sub-search-type-filter">Maximum Acres</span>
              <input class="form-control text-search-entry"
                v-validate="'max_decimal:4'"
                placeholder="Enter Maximum Acres"
                name="maximumAcres"
                data-vv-as="Maximum Acres"
                v-model="maximumAcres"/>
              <div class="invalid-feedback">{{ errors.first('maximumAcres') }}</div>
            </div>
          </div>
        </b-collapse>
      </div>
    </div>
    <div class="row search-filter-category">
      <div class="col-12">
        <a v-b-toggle="`collapse-calculated-rights-facet`" class="facet-collapse-icon c-pointer">
          <font-awesome-icon
            class="when-opened "
            icon='caret-down'
            size="lg" />
          <font-awesome-icon
            class="when-closed fa-w-10"
            icon='caret-right'
            size="lg" />
        </a>
        <span class="font-weight-bold ">Allowed Rights</span>
        <b-collapse :id="`collapse-calculated-rights-facet`"
          class="row"
          :visible="initialSearchCategoryStates['rights']">
          <div class="search-panel-items search-panel-no-border search-filter-list">
            <div class="search-panel-sub-item">
              <span class="sub-search-type-filter">Dwellings</span>
              <b-form-checkbox
                v-model="exceedsAllowedDwellings"
                :value="true"
                :unchecked-value="null"
                class="col-md-12 noselect">
                  Exceeds Allowed Rights
              </b-form-checkbox>
              <b-form-checkbox
                v-model="doesNotExceedAllowedDwellings"
                :value="true"
                :unchecked-value="null"
                class="col-md-12 noselect">
                  Does Not Exceed Allowed Rights
              </b-form-checkbox>
            </div>
            <div class="search-panel-sub-item">
              <span class="sub-search-type-filter">Finished Area</span>
              <b-form-checkbox
                v-model="exceedsAllowedFinishedArea"
                :value="true"
                :unchecked-value="null"
                class="col-md-12 noselect">
                  Exceeds Allowed Rights
              </b-form-checkbox>
              <b-form-checkbox
                v-model="doesNotExceedAllowedFinishedArea"
                :value="true"
                :unchecked-value="null"
                class="col-md-12 noselect">
                  Does Not Exceed Allowed Rights
              </b-form-checkbox>
            </div>
            <div class="search-panel-sub-item">
              <span class="sub-search-type-filter">Impervious Surface</span>
              <b-form-checkbox
                v-model="exceedsAllowedImperviousSurface"
                :value="true"
                :unchecked-value="null"
                class="col-md-12 noselect">
                  Exceeds Allowed Rights
              </b-form-checkbox>
              <b-form-checkbox
                v-model="doesNotExceedAllowedImperviousSurface"
                :value="true"
                :unchecked-value="null"
                class="col-md-12 noselect">
                  Does Not Exceed Allowed Rights
              </b-form-checkbox>
            </div>
          </div>
        </b-collapse>
      </div>
    </div>
  </div>
</template>
<script>
import { mapGetters, mapState } from 'vuex';
import { LookupModules } from '@/store/moduleConfig';
import MultiTextSearchFacet from '@/components/search/MultiTextSearchFacet.vue';
import SearchFacetOptions from '@/components/search/SearchFacetOptions.vue';

export default {
  name: 'PropertySearchFacets',
  components: {
    MultiTextSearchFacet,
    SearchFacetOptions,
  },
  computed: {
    ...mapState(LookupModules.AGREEMENT_TYPES.namespace, {
      agreementTypeOptionsLoading: state => state.loading,
    }),
    ...mapState(LookupModules.LOCALITIES.namespace, {
      localityLoading: state => state.loading,
    }),
    ...mapState(LookupModules.PROPERTY_STATUSES.namespace, {
      propertyStatusOptionsLoading: state => state.loading,
    }),
    ...mapGetters(LookupModules.AGREEMENT_TYPES.namespace, {
      agreementTypeOptions: 'getActiveOptions',
    }),
    ...mapGetters(LookupModules.LOCALITIES.namespace, {
      localityOptions: 'getActiveOptions',
    }),
    ...mapGetters(LookupModules.PROPERTY_STATUSES.namespace, {
      propertyStatusOptions: 'getActiveOptions',
    }),
    initialSearchCategoryStates() {
      return this.$store.state.Search.initialSearchCategoryStates;
    },
    minimumAcres: {
      get() {
        return this.$store.state.Search.selectedSearchFacets.minimumAcres[0];
      },
      set(value) {
        this.updateFacet('minimumAcres', value);
      },
    },
    maximumAcres: {
      get() {
        return this.$store.state.Search.selectedSearchFacets.maximumAcres[0];
      },
      set(value) {
        this.updateFacet('maximumAcres', value);
      },
    },
    exceedsAllowedDwellings: {
      get() {
        return this.$store.state.Search.selectedSearchFacets.exceedsAllowedDwellings[0];
      },
      set(value) {
        this.updateFacet('exceedsAllowedDwellings', value ? [value] : []);
      },
    },
    doesNotExceedAllowedDwellings: {
      get() {
        return this.$store.state.Search.selectedSearchFacets.doesNotExceedAllowedDwellings[0];
      },
      set(value) {
        this.updateFacet('doesNotExceedAllowedDwellings', value ? [value] : []);
      },
    },
    exceedsAllowedFinishedArea: {
      get() {
        return this.$store.state.Search.selectedSearchFacets.exceedsAllowedFinishedArea[0];
      },
      set(value) {
        this.updateFacet('exceedsAllowedFinishedArea', value ? [value] : []);
      },
    },
    doesNotExceedAllowedFinishedArea: {
      get() {
        return this.$store.state.Search.selectedSearchFacets.doesNotExceedAllowedFinishedArea[0];
      },
      set(value) {
        this.updateFacet('doesNotExceedAllowedFinishedArea', value ? [value] : []);
      },
    },
    exceedsAllowedImperviousSurface: {
      get() {
        return this.$store.state.Search.selectedSearchFacets.exceedsAllowedImperviousSurface[0];
      },
      set(value) {
        this.updateFacet('exceedsAllowedImperviousSurface', value ? [value] : []);
      },
    },
    doesNotExceedAllowedImperviousSurface: {
      get() {
        return this.$store.state.Search.selectedSearchFacets
          .doesNotExceedAllowedImperviousSurface[0];
      },
      set(value) {
        this.updateFacet('doesNotExceedAllowedImperviousSurface', value ? [value] : []);
      },
    },
  },
  mounted() {
    this.$store.dispatch(`${LookupModules.LOCALITIES.namespace}/fetchOptions`,
      LookupModules.LOCALITIES.url);
    this.$store.dispatch(`${LookupModules.AGREEMENT_TYPES.namespace}/fetchOptions`,
      LookupModules.AGREEMENT_TYPES.url);
    this.$store.dispatch(`${LookupModules.PROPERTY_STATUSES.namespace}/fetchOptions`,
      LookupModules.PROPERTY_STATUSES.url);
  },
  methods: {
    updateFacet(fieldName, value) {
      this.$store.dispatch(
        'Search/updateSearchFacet',
        {
          type: fieldName,
          values: value,
        },
      );
    },
  },
};
</script>
